import { UserFacingError } from './errors'

export class GalleryPhotoAccessDeniedError extends UserFacingError {
  constructor() {
    super('You can only edit or delete photos you uploaded.')
    this.name = 'GalleryPhotoAccessDeniedError'
  }
}

export class GalleryPhotoNotFoundError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'This photo no longer exists.')
    this.name = 'GalleryPhotoNotFoundError'
  }
}
